import addClass from './addClass';
import hide from './hide';
import removeClass from './removeClass';
import show from './show';
import fadeIn from './fadeIn';
import fadeOut from './fadeOut';
import html from './html';
import slideDown from './slideDown';
import slideUp from './slideUp';
import animate from './animate';

export default function modQuery(selector) {
	const elements = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector];

	return {
		elements,
		addClass(classes) {
			this.elements.forEach((el) => addClass(el, classes));
			return this;
		},
		removeClass(classes) {
			this.elements.forEach((el) => removeClass(el, classes));
			return this;
		},
		show(updateTabIndex, addAriaHidden, displayValue) {
			this.elements.forEach((el) => show(el, updateTabIndex, addAriaHidden, displayValue));
			return this;
		},
		hide(updateTabIndex, addAriaHidden) {
			this.elements.forEach((el) => hide(el, updateTabIndex, addAriaHidden));
			return this;
		},
		slideUp(duration, updateTabIndex, addAriaHidden) {
			this.elements.forEach((el) => slideUp(el, duration, updateTabIndex, addAriaHidden));
			return this;
		},
		slideDown(duration, updateTabIndex, addAriaHidden) {
			this.elements.forEach((el) => slideDown(el, duration, updateTabIndex, addAriaHidden));
			return this;
		},
		fadeIn(duration, updateTabIndex, addAriaHidden) {
			this.elements.forEach((el) => fadeIn(el, duration, updateTabIndex, addAriaHidden));
			return this;
		},
		fadeOut(duration, updateTabIndex, addAriaHidden) {
			this.elements.forEach((el) => fadeOut(el, duration, updateTabIndex, addAriaHidden));
			return this;
		},
		html(content) {
			let markup = null;
			this.elements.forEach((el) => markup = html(el, content));
			return markup || this;
		},
		animate(styles, duration, easing, callback) {
			this.elements.forEach((el) => animate(el, styles, duration, easing, callback));
			return this;
		}
	};
}

window.modQuery = modQuery;
